var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedOrderIds.length
    ? _c(
        "div",
        {
          class: [
            "table-bulk-action-container",
            _vm.topScrollPosition > 150 ? "sticky" : "",
          ],
        },
        [
          _c("div", [
            _vm._v(
              _vm._s(_vm.selectedOrderIds.length) +
                " order" +
                _vm._s(_vm.selectedOrderIds.length > 1 ? "s" : "") +
                " selected."
            ),
          ]),
          _c(
            "div",
            [
              _vm.actionsToDisplay.includes("sendSchedulingLink")
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-warning bulk-action-btn",
                      attrs: { title: "Send SMS" },
                      on: { click: _vm.sendSchedulingLink },
                    },
                    [
                      _c("md-icon", [_vm._v("schedule_send")]),
                      _vm._v("\n            Send SMS\n        "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.actionsToDisplay.includes("batchAssign")
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-success bulk-action-btn",
                      attrs: { title: "Batch Assign to Carrier" },
                      on: { click: _vm.handleBatchAssignClicked },
                    },
                    [_vm._v("\n            Batch assign to carrier\n        ")]
                  )
                : _vm._e(),
              _vm.actionsToDisplay.includes("readyForPacking")
                ? _c(
                    "md-button",
                    {
                      staticClass:
                        "md-button-custom-ready-for-packing bulk-action-btn",
                      attrs: { title: "Ready for Packing" },
                      on: { click: _vm.handleReadyForPackingClicked },
                    },
                    [_vm._v("\n            Ready for Packing\n        ")]
                  )
                : _vm._e(),
              _vm.actionsToDisplay.includes("bookNow")
                ? _c(
                    "md-button",
                    {
                      staticClass: "md-success bulk-action-btn",
                      attrs: { title: "Book Now" },
                      on: { click: _vm.handleBookNowClicked },
                    },
                    [_vm._v("\n            Book Now\n        ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }